import React, { useCallback } from 'react';
import { SpreadsheetDocumentsData } from '../../models/SpreadsheetDocument';
import {
  NetworkSpreadsheetService,
  DEFAULT_NETWORK_COLUMNS,
} from '../../services/NetworkSpreadsheetService';
import SpreadsheetDocuments from '../../components/spreadsheet-docs/SpreadsheetDocuments';
import { getUserInfo } from '../../utils/auth';

interface NetworkSpreadsheetProps {
  projectId: number;
}

/**
 * IP / 네트워크 스프레드시트 — 다중 문서.
 *
 * 업로드한 엑셀의 시트별로 제목 토글로 펼치는 문서를 만든다. 기존 문서에 행 append, 엑셀 내보내기,
 * 삭제, 제목 수정 지원. 저장은 projects.network_spreadsheet JSON 컬럼.
 * 편집은 admin/editor 만 (백엔드 PUT 권한과 동일).
 */
const NetworkSpreadsheet: React.FC<NetworkSpreadsheetProps> = ({ projectId }) => {
  const role = getUserInfo()?.role;
  const writable = role === 'admin' || role === 'editor';

  const load = useCallback(() => NetworkSpreadsheetService.get(projectId), [projectId]);
  const save = useCallback(
    (data: SpreadsheetDocumentsData) => NetworkSpreadsheetService.update(projectId, data),
    [projectId],
  );

  return (
    <SpreadsheetDocuments
      load={load}
      save={save}
      writable={writable}
      title="IP / 네트워크 스프레드시트"
      description="💡 여러 엑셀/CSV 파일 또는 폴더를 선택해 한 번에 가져올 수 있습니다. 여러 파일과 폴더는 모든 시트를 개별 문서로 등록합니다. 문서의 이동 손잡이를 드래그하거나 순서 번호를 선택해 위치를 바꾸세요. 제목을 눌러 펼치고 셀을 직접 편집할 수 있으며, 내용과 순서는 자동 저장됩니다."
      defaultColumns={DEFAULT_NETWORK_COLUMNS}
      newDocName="네트워크 문서"
      exportPrefix="network"
      allowFolderUpload
      allowReorder
      allowAllSheetsImport
    />
  );
};

export default NetworkSpreadsheet;
